<div class="iframe-container" (resized)="onResized()">
    <iframe *ngIf="url" [src]="url | safe:'resourceUrl'" frameborder="0" class="w-100 iframe-analytics"
        [ngStyle]="{height: frameHeight}"></iframe>
</div>